// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Y12L","containerItemsCenter":"Skeleton_containerItemsCenter__3JCdD"};